import React from 'react'
import {
  Box,
} from '@material-ui/core'

const TrueFalseTextMessage = props => {
  return (
    <React.Fragment>
      <Box className='innerFormContainer'>
        <Box className='innerFormItem'>
          <label>Message</label>
          <span>Displays text alongside the checkbox</span>
        </Box>
        <Box className='innerFormItem'>
          <input
            type="text"
            name="treufalse_text"
            value={props.value}
            onChange={props.onChance}
          />
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default TrueFalseTextMessage
